import React, { useContext, useState } from 'react';
import { FaEdit, FaCamera, FaSave, FaLock, FaEnvelope } from 'react-icons/fa';
import { UserContext } from '../context';

import { FaUserTag } from "react-icons/fa6";
import Validate from '../shared/validation/Validate';

const MyProfile = () => {

    // to get userData from the state
    const { state } = useContext(UserContext);


    const [editing, setEditing] = useState(false); // Track if in edit mode
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errors, setErrors] = useState('');


    // Handle form submission for changing password
    const handlePasswordChange = (e) => {
        e.preventDefault();
        if (newPassword !== confirmPassword) {
            setErrors('Passwords do not match.');
            return;
        }
        // Submit password change logic here (e.g., API call)
        setErrors('');
        alert('Password changed successfully!');
    };

    // Handle image change
    const handleProfilePicChange = (e) => {
        // Logic for changing profile picture
        alert('Profile picture updated!');
    };

    return (
        <Validate>
            <div className="min-h-screen bg-gray-100 py-10 px-4 sm:px-6 lg:px-8">
                <div className="max-w-4xl mx-auto bg-white p-6 rounded-lg shadow-md">
                    <div className="flex items-center space-x-6">
                        {/* Profile Picture */}
                        <div className="relative">
                            {state && state.user.profileImage ? (
                                <img src={state && state.user.profileImage} alt="Profile" className="w-32 h-32 rounded-full object-cover" />
                            ) : (
                                <div className="w-32 h-32"><FaUserTag className='w-32 h-32 rounded-full border-2' /></div>
                            )}

                            <button
                                onClick={handleProfilePicChange}
                                className="absolute bottom-0 right-0 bg-blue-500 text-white p-2 rounded-full shadow-md hover:bg-blue-400">
                                <FaCamera className="text-xl" />
                            </button>
                        </div>

                        {/* User Details */}
                        <div className="space-y-4">
                            <div className="flex items-center space-x-2">
                                {editing ? (
                                    <input
                                        type="email"
                                        defaultValue={state && state.user.name}
                                        className="bg-gray-100 p-2 rounded-md w-64"
                                    />
                                ) : (
                                    <h2 className="text-3xl font-semibold text-gray-800">{state && state.user.name}</h2>
                                )}

                                <button
                                    onClick={() => setEditing(editing => !editing)}
                                    className="text-blue-500 hover:text-blue-700"
                                >
                                    <FaEdit />
                                </button>
                            </div>
                            <div className="text-gray-600 flex">
                                <div className="flex items-center space-x-2">
                                    <FaEnvelope />
                                    {editing ? (
                                        <input
                                            type="email"
                                            defaultValue={state && state.user.email}
                                            className="bg-gray-100 p-2 rounded-md w-64"
                                        />
                                    ) : (
                                        <span>{state && state.user.email}</span>
                                    )}
                                </div>
                                {editing ? <button type="submit" className="w-24 h-8 bg-blue-600 text-white py-1 px-2 mt-2 ml-5 rounded-md hover:bg-blue-700 flex items-center justify-center">
                                    <FaSave className="mr-2" />
                                    Update
                                </button> : null}
                            </div>
                        </div>
                    </div>

                    {/* Password Change Form */}
                    <div className="mt-16 space-y-4">
                        <h3 className="text-xl font-semibold text-gray-800">Change Password</h3>
                        <form onSubmit={handlePasswordChange} className="space-y-2">
                            {errors && (
                                <div className="text-red-500 text-sm">{errors}</div>
                            )}
                            <div>
                                <label htmlFor="newPassword" className="block text-sm font-medium text-gray-700">Old Password</label>
                                <div className="mt-1">
                                    <input
                                        id="oldPassword"
                                        name="oldPassword"
                                        type="password"
                                        value={oldPassword}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                        className="bg-gray-100 py-1 px-2 rounded-md w-72"
                                        required
                                    />
                                </div>
                            </div>
                            <div>
                                <label htmlFor="newPassword" className="block text-sm font-medium text-gray-700">New Password</label>
                                <div className="mt-1">
                                    <input
                                        id="newPassword"
                                        name="newPassword"
                                        type="password"
                                        value={newPassword}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                        className="bg-gray-100 py-1 px-2 rounded-md w-72"
                                        required
                                    />
                                </div>
                            </div>
                            <div>
                                <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700">Confirm Password</label>
                                <div className="mt-1">
                                    <input
                                        id="confirmPassword"
                                        name="confirmPassword"
                                        type="password"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        className="bg-gray-100 py-1 px-2 rounded-md w-72"
                                        required
                                    />
                                </div>
                            </div>
                            <div>
                                <button
                                    type="submit"
                                    className="w-72 bg-blue-600 text-white py-1 px-2 mt-7 rounded-md hover:bg-blue-700 flex items-center justify-center"
                                >
                                    <FaSave className="mr-2" />
                                    Update Password
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Validate>

    );
};

export default MyProfile;